import { forwardRef, useEffect } from 'react'
import ChallengesHeader from '../header/ChallengesHeader'
import { useCheckOnCompleteSomeQuests } from '../../../../../hooks/useCheckOnCompleteSomeQuests'
import { useGetPrizeFromQuest } from '../../../../../hooks/useGetPrizeFromQuest'
import AppLoader from '../../../../features/appLoader/AppLoader'
import ChallengesList from '../challenges-list/ChallengesList'
import AchievesList from '../achieves-list/AchievesList'
import { useRequestsHandlerData } from '../../../../../hooks/useRequestsHandlerData'
import useChallengesModals from '../../model/hooks/useChallengesModals'
import classNames from 'classnames'
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks'
import { useRequests } from '../../../../../redux/reducer/requests'
import { SwitchTransition, CSSTransition } from 'react-transition-group'
import { useChallenges } from '../../../../../redux/reducer/content'
import { ACHIEVEMENTS, CHALLENGES } from '../../constants/tabs'
import { useChangesAugust2026 } from '../../../../../hooks/useChangesAugust2026'
import { august2026ChangesData } from '../../../../../constants/copyright'

const challengesLists = {
  [CHALLENGES]: ChallengesList,
  [ACHIEVEMENTS]: AchievesList,
}

const Challenges = forwardRef(function (_, ref) {
  const { activeTab } = useChallenges()
  const {
    authData: { isWeb },
  } = useRequests()

  const ContentList = challengesLists[activeTab]
  const callbacks = useApplicationCallbacks()
  const isPending = useGetPrizeFromQuest({ callbacks })

  useRequestsHandlerData(
    ['requestsGameCompleteQuest', 'requestsGameCollectQuest'].map((address) => ({
      address,
      fulfilled: callbacks.getQuests,
    })),
  )

  useEffect(() => {
    if (activeTab === ACHIEVEMENTS) {
      callbacks.getIcons()
    }

    if (activeTab === CHALLENGES) {
      callbacks.getQuests()
    }
  }, [activeTab, callbacks])

  useCheckOnCompleteSomeQuests()
  useChallengesModals()
  useChangesAugust2026(august2026ChangesData.challenges.serviceDataKey)

  return (
    <div
      className={classNames('challenges', { app: !isWeb })}
      ref={ref}
    >
      <ChallengesHeader />
      <SwitchTransition>
        <CSSTransition
          key={activeTab}
          timeout={300}
          classNames={'challenges__block'}
        >
          <ContentList />
        </CSSTransition>
      </SwitchTransition>
      {isPending && <AppLoader showAbortButton={true} />}
    </div>
  )
})
export default Challenges
Challenges.propTypes = {}
